import httpClient from '../utils/httpClient';

interface SsoTokenResponse {
  success: boolean;
  ssoToken: string;
  crmUrl: string;
}

interface MkraftoneTokenResponse {
  success: boolean;
  ssoToken: string;
  mkraftoneUrl: string;
}

export const ssoService = {
  /**
   * Generate a short-lived SSO token for CRM login.
   * Requires the user to be authenticated in Nucleus.
   */
  generateCrmToken: async (): Promise<SsoTokenResponse> => {
    // httpClient interceptor already unwraps response.data, so return directly
    const data = await httpClient.post<SsoTokenResponse>('/auth/sso/generate-crm-token');
    return data;
  },

  generateMkraftoneToken: async (): Promise<MkraftoneTokenResponse> => {
    const data = await httpClient.post<MkraftoneTokenResponse>('/auth/sso/generate-mkraftone-token');
    return data;
  },
};

export default ssoService;
